export const LOAD_LEVELS = "LOAD_LEVELS";
export const LOAD_LEVELS_SUCCESS = "LOAD_LEVELS_SUCCESS";
export const LOAD_LEVELS_ERROR = "LOAD_LEVELS_ERROR";
export const UPDATE_LEVEL = "UPDATE_LEVEL";
export const UPDATE_LEVEL_SUCCESS = "UPDATE_LEVEL_SUCCESS";
export const DELETE_LEVEL = "DELETE_LEVEL";
export const DELETE_LEVEL_SUCCESS = "DELETE_LEVEL_SUCCESS";
